jQuery(document).ready(function($) {

	const $body = $('body');
	const $window = $(window);
	const $document = $(document);
	const $html = $('html');
	
	smoothScroll($);
	hamburgerToggle($, $body, $window);
	submenuToggle($, $body, $window);
	pageIsScrolled($, $body, $window, $document);
	searchModal($, $body);

	// launch AOS at first scroll tick
	var aosinit = false;
	if(!aosinit){
		AOS.init({
			offset: 0,
			duration: 800
		});
		aosinit = true;
	}

});

jQuery(window).on("load", function(e) {
	jQuery("body").removeClass("preload");
});

function searchModal($, $body) {
	$trigger = $('.js-search-trigger');
	$trigger.on('click', function (e) {
		e.preventDefault();
		$body.toggleClass('search-active');
	});
}


function pageIsScrolled($, $body, $window, $document) {

	scrollClasses();
 
	$window.on( 'scroll', function() {
		scrollClasses();
	});

	function scrollClasses() {		
		var $spacer = µSpacer(2.5);
		$body.toggleClass('scrolled', $document.scrollTop() > 0);		
	}

}

function hamburgerToggle($, $body, $window) {
	const $hamburgerIcon = $('.hamburger-toggle');
	$hamburgerIcon.on("click", function(e) {
		$('html').toggleClass('primary-menu-active');
	});
}

function submenuToggle($, $body, $window) {
	const $subMenu = $('.menu-item-has-children > a');
	$subMenu.on("click", function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('.menu-item-has-children').removeClass('submenu-menu-active');
		$(this).parent().toggleClass('submenu-menu-active');
	});
	$window.on('click', function() {
		$('.menu-item-has-children.submenu-menu-active').removeClass('submenu-menu-active');
	});
}


function getCssVar(type, cssvar, intslice = -2) {
	let cssvalue = '';	
	if ( 'CSS' in window && CSS.supports && CSS.supports('(--foo: red)' ) ) {
		if(type == 'int'){
			cssvalue = parseInt(getComputedStyle(document.documentElement).getPropertyValue(cssvar).slice(0,intslice));
		}
		if(type == 'string'){
			cssvalue = getComputedStyle(document.documentElement).getPropertyValue(cssvar);
		}
	}
	return cssvalue;
}

function µSpacer(factor = 1) {
	let spacer = 32;
	if ( 'CSS' in window && CSS.supports && CSS.supports('(--foo: red)' ) ) {
		spacer = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--spacer-current').slice(0,-2));
	}
	return spacer * factor;
}

function smoothScroll($) {
	$('a[href*=\\#]:not([href=\\#])').click(function(e) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				smoothScrollTo(target);
				e.preventDefault();
			}
		}				
	});
}

function formAjax($, $form, localizedData, test = false ) {
	if ( test ) fieldsAutofill($form);
    $form.on('submit',function(e){
        e.preventDefault();
        sendAjax($form, localizedData, function(res) {
            if ( res.success === true ) {
				console.log(res);
                $form.find('.error').remove();
                $('<div class="success">'+localizedData.strings.sentMessageText+'</div>').insertAfter($form.find('[type="submit"]'));
            }
            else {
                console.log(res);
                $form.find('.success').remove();
				if ( res.data[0].code === 'existing_user_login' ) {
					$('<div class="error">'+localizedData.strings.existingUser+'</div>').insertAfter($form.find('[type="submit"]'));
				}
				else {
					$('<div class="error">'+localizedData.strings.error+'</div>').insertAfter($form.find('[type="submit"]'));
				}
            }
        });
    });
}

function fieldsAutofill( $form ) {

	$form.find('input').each( function () {
		const $input = $(this);
		switch ( $input.attr('type') ) {
			case 'text':
				$input.val($input.attr('name'));
				break;
			case 'email':
				$input.val('noe.zylmans@indev.be');
				break;
			case 'number':
				$input.val(10);
				break;
			case 'checkbox':
				$input.attr('checked', true);
				break;
		}
	});

	$form.find('textarea').each( function () {
		const $input = $(this);
		$input.val($input.attr('name'));
	});

	$form.find('select').each( function () {
		const $select = $(this);
		$select.find('option').last().attr("selected", true);
	});

}

function sendAjax($form, settings, callback) {
	
	(function ($) {

        grecaptcha.ready(function() {

			grecaptcha.execute( settings.reCaptcha.siteKey, {action: settings.reCaptcha.action}).then(function(token) {

				$form.ajaxSubmit({
					url: settings.adminAjaxUrl,
					type: 'POST',
					contentType: 'json',
					beforeSubmit: function(formData, jqForm, options) {
						let error = false;
						for ( var i = 0; i < formData.length; i++ ) {
							if ( formData[i].required && !formData[i].value ) {
								error = true;
								$form.find('[name='+formData[i].name+']').addClass('required');
							}
						}
						if ( error ) {
							return false;
						}
					},
					data: {
						token: token,
					},
					success: function(res) {
						if (callback) callback(res);
						if (res.success != true) {
							console.log(res);
						}
					}
				});

			});
			
		});

	})(jQuery);

}

function smoothScrollTo($target, offset = null) {
	offset = offset ? offset : µSpacer(2);
	$('html,body').animate({
		scrollTop: $target.offset().top - offset
	}, 800);
}


/**
 * inViewport jQuery plugin by Roko C.B.
 * http://stackoverflow.com/a/26831113/383904
 * Returns a callback function with an argument holding
 * the current amount of px an element is visible in viewport
 * (The min returned value is 0 (element outside of viewport)
 */
 ;(function($, win) {
	$.fn.inViewport = function(cb) {
	   	return this.each(function(i,el) {
			function visPx(){
				var elH = $(el).outerHeight(),
					H = $(win).height(),
					r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
				return cb.call(el, Math.max(0, t>0? Math.min(elH, H-t) : Math.min(b, H)));  
			}
		visPx();
	   });
	};
  }(jQuery, window));


/**
 * Returns string content of a cookie
 * @param {string} k Cookie name
 */
function getCookie(k){
    var v=document.cookie.match('(^|;) ?'+k+'=([^;]*)(;|$)');
    return v?v[2]:null
}

/**
 * 
 * @param {string} name Name of the cookie to be set
 * @param {*} data Content of the cookie
 * @param {number} hours Max age hours
 * @param {number} days Max age days
 */
function setCookie( name, data, hours = 24, days = 1 ) {

    if (data === null)
        return;

    const maxAge = days*hours*60*60;

    document.cookie = name + '=' + data + '; max-age=' + maxAge + '; path=/';

}

/**
 * 
 * @param {string} name Name of the cookie to be set
 * @param {*} data Content of the cookie, the object will be stringified
 * @param {number} hours Max age hours
 * @param {number} days Max age days
 */
 function setCookieObj( name, data, hours = 1, days = 1 ) {

    if (data === null)
        return;

    const maxAge = days*hours*60*60;

    data = JSON.stringify(data);
    
    document.cookie = name + '=' + data + '; max-age=' + maxAge + '; path=/';

}

/**
 * Retrives cookie, unstringifies it's content, set new keys values and replace it
 * @param {Object} data Object of keys to be updated
 * @param {string} name Name of the cookie to be set
 * @param {number} hours Max age hours
 * @param {number} days Max age days
 */
 function setCookieObjKeys(  name = 'user-filter', data = {}, hours = 1, days = 1 ) {

    const cookieString = getCookie( name );
    let cookieObj = {};

    if ( cookieString ) {
		
        cookieObj = JSON.parse(cookieString);

        for ( const [key,value] of Object.entries( data ) ) {
            // if the value has not been clearly specified as null/false/0 do not set the key
            if ( value.length || typeof value === 'object'  || typeof value === 'number') {
                cookieObj[key] = value;
            }

        }

    }
    else {
        cookieObj = data;
    }

    setCookieObj( name, cookieObj, hours, days );

}



function datePickersInit( $datePickers) {

    if ( !$datePickers.length ) return;

    $datePickers.each(function() {

        const $datePicker = $(this);
        const minDate = $datePicker.data('min');
        const maxDate = $datePicker.data('max');
        const args = {
			dateFormat: 'dd/mm/yy',
		};

        if ( maxDate ) args.maxDate = new Date(maxDate);
        if ( minDate ) args.minDate = new Date(minDate);

        $datePicker.datepicker(args);

    });

}